module.exports = __webpack_public_path__ + "img/bg.94cb8bbc.png";